import React, { useEffect, useState, Component } from 'react';
import { Check, Star, ShieldCheck, Download, Zap, Layers, Scissors, Package, DollarSign, Clock, Shield, CreditCard } from 'lucide-react';
import { Button } from './components/ui/Button';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FAQ } from './components/FAQ';
// Image Constants
const IMAGES = {
  HERO: 'https://cdn.magicpatterns.com/uploads/krsjkuDC7ckSicWQiHVvMX/Mockup_principal.png',
  HEADER_2200: 'https://cdn.magicpatterns.com/uploads/tiyFRcTjLPHDEeHgusfBvj/2200.png',
  P1: 'https://cdn.magicpatterns.com/uploads/t9cNRfVUqNukXgU6Zewq2V/P1.png',
  P2: 'https://cdn.magicpatterns.com/uploads/rcey4SvLUeheTX4cKWNLk2/P2.png',
  P3: 'https://cdn.magicpatterns.com/uploads/9RCr9HFPxW86fwqZDn4rX3/P3.png',
  PACK1: 'https://cdn.magicpatterns.com/uploads/7LEjMB1D4Xg95rfH6eHJW3/PACK1.png',
  PACK2: 'https://cdn.magicpatterns.com/uploads/59nVqF1GQF9MKiBApJYucd/PACK2.png',
  PACK3: 'https://cdn.magicpatterns.com/uploads/6Ju3hRvD42WtqQCJHjAHR6/PACK3.png',
  T1: 'https://cdn.magicpatterns.com/uploads/26WvknVLYAAhP22yuGVzcU/T1.png',
  T3: 'https://cdn.magicpatterns.com/uploads/hGdP1k8tRTjadtz82K1tRp/T3.png',
  T4: 'https://cdn.magicpatterns.com/uploads/2iL4NVkJYNo6xoD3xi1gBK/T4.png'
};
// Countdown Timer Component
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 17,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) {
            return {
              minutes: 17,
              seconds: 0
            }; // Reset
          }
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-0">
      <div className="bg-gray-900 border border-gray-700 rounded-xl px-4 md:px-6 py-3 md:py-4" data-id="element-1">
        <span className="text-3xl md:text-5xl font-bold text-white font-mono" data-id="element-2">
          {String(timeLeft.minutes).padStart(2, '0')}
        </span>
        <span className="block text-xs text-gray-400 mt-1" data-id="element-3">MINUTOS</span>
      </div>
      <span className="text-3xl md:text-5xl font-bold text-[#F59E0B]" data-id="element-4">:</span>
      <div className="bg-gray-900 border border-gray-700 rounded-xl px-4 md:px-6 py-3 md:py-4" data-id="element-5">
        <span className="text-3xl md:text-5xl font-bold text-white font-mono" data-id="element-6">
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <span className="block text-xs text-gray-400 mt-1" data-id="element-7">SEGUNDOS</span>
      </div>
    </div>;
}
export function App() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen font-sans text-gray-900 overflow-x-hidden" data-id="element-8">
      <SocialProofPopup data-id="element-9" />

      {/* 1. HERO SECTION (Black) */}
      <section className="bg-black text-white pt-6 pb-4 md:pt-8 md:pb-6 px-4" data-id="element-10">
        <div className="max-w-4xl mx-auto text-center space-y-5" data-id="element-11">
          {/* Imagen 2200 al inicio - tamaño compacto */}
          <img src={IMAGES.HEADER_2200} alt="Ultrapack Reviews" className="w-44 mx-auto h-auto object-contain" data-id="element-12" />

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-13">
            Todo lo que necesitás para{' '}
            <span className="text-[#F59E0B]" data-id="element-14">empezar a vender</span>, ya
            resuelto.
          </h1>

          {/* Mockup principal */}
          <div className="py-4" data-id="element-15">
            <img src={IMAGES.HERO} alt="Ultrapack Mockup Principal" className="w-full max-w-2xl mx-auto h-auto object-contain drop-shadow-2xl" data-id="element-16" />
          </div>

          <p className="text-xl text-gray-300" data-id="element-17">
            Sin diseñar, sin perder tiempo, sin gastar de más.
          </p>
        </div>
      </section>

      {/* 3. PRODUCT SHOWCASE (Black) */}
      <section className="bg-black text-white pt-4 pb-16 px-4" data-id="element-18">
        <div className="max-w-7xl mx-auto text-center" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-20">
            Cortás, Empacás, <span className="text-[#F59E0B]" data-id="element-21">Vendés.</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-22">
            {[IMAGES.P1, IMAGES.P2, IMAGES.P3].map((img, idx) => <div key={idx} className="rounded-xl overflow-hidden border border-gray-800 hover:border-[#F59E0B] transition-colors group aspect-square" data-id="element-23">
                <img src={img} alt={`Producto ${idx + 1}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-24" />
              </div>)}
          </div>
          <p className="text-gray-400 italic" data-id="element-25">
            Imágenes de productos fabricados con nuestros diseños
          </p>
        </div>
      </section>

      {/* 4. TARGET AUDIENCE (White) */}
      <section className="bg-white py-16 px-4" data-id="element-26">
        <div className="max-w-4xl mx-auto" data-id="element-27">
          <div className="text-center mb-12" data-id="element-28">
            <h2 className="text-3xl font-bold mb-4" data-id="element-29">
              ¿Este Ultrapack es para vos?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-30">
              Fijate si te sentís identificado 👇
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-31">
            {[{
            title: 'Querés algo simple',
            desc: 'No querés complicarte con cursos largos ni procesos eternos. Buscás archivos claros, fáciles y listos para usar.'
          }, {
            title: 'Querés resultados rápidos',
            desc: 'Estás cansado de postergar. Necesitás empezar ahora, no "cuando tenga tiempo".'
          }, {
            title: 'Querés vender con sentido',
            desc: 'Te importa que lo que producís tenga valor real y que lo que vendés se pueda entregar, usar y cobrar.'
          }, {
            title: 'Tenés lo básico (o estás por tenerlo)',
            desc: 'Si ya tenés una máquina de corte láser, arrancás hoy. Y si todavía no, podés ir armando catálogo y tomando pedidos.'
          }].map((item, idx) => <div key={idx} className="p-6 bg-gray-50 rounded-xl border border-gray-100 hover:shadow-md transition-shadow" data-id="element-32">
                <h3 className="flex items-center gap-2 text-xl font-bold mb-3" data-id="element-33">
                  <span className="text-[#F59E0B]" data-id="element-34">🔹</span> {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-35">{item.desc}</p>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-[#F59E0B]/10 p-6 rounded-xl border border-[#F59E0B]/20" data-id="element-36">
            <p className="text-lg font-medium" data-id="element-37">
              Si te sentiste identificado con al menos 2 puntos… <br data-id="element-38" />
              <span className="text-2xl font-bold text-[#F59E0B]" data-id="element-39">
                👉 Este pack está hecho para vos.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* 5. BENEFITS (Black) */}
      <section className="bg-black text-white py-16 px-4" data-id="element-40">
        <div className="max-w-7xl mx-auto" data-id="element-41">
          <div className="text-center mb-12" data-id="element-42">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-43">
              ¿Qué vas a lograr con este pack?
            </h2>
            <p className="text-xl text-gray-400" data-id="element-44">
              Resultados claros, simples y accionables.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-45">
            {[{
            title: 'Empezar sin complicarte',
            desc: 'No necesitás saber diseñar ni perder horas probando. Los archivos ya están listos para que arranques directo.'
          }, {
            title: 'Vender más rápido',
            desc: 'Usás diseños que ya están listos para cortar, armar y vender, sin fricción ni pasos innecesarios.'
          }, {
            title: 'Ahorrar tiempo y plata',
            desc: 'Te evitás pagar diseñadores, cursos o pruebas eternas. Acá ya tenés un catálogo enorme listo para producir.'
          }, {
            title: 'Avanzar paso a paso',
            desc: 'Si ya tenés máquina, arrancás hoy. Y si todavía no, podés ir armando tu catálogo y tomando pedidos para validar antes de invertir más.'
          }].map((item, idx) => <div key={idx} className="bg-gray-900 p-6 rounded-xl border border-gray-800 hover:border-[#F59E0B] transition-colors" data-id="element-46">
                <div className="w-12 h-12 bg-[#F59E0B]/20 rounded-full flex items-center justify-center mb-4 text-[#F59E0B]" data-id="element-47">
                  <Check className="w-6 h-6" data-id="element-48" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-49">{item.title}</h3>
                <p className="text-gray-400 text-sm" data-id="element-50">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. TESTIMONIALS (White) */}
      <section className="bg-white py-16 px-4" data-id="element-51">
        <div className="max-w-7xl mx-auto text-center" data-id="element-52">
          <h2 className="text-3xl font-bold mb-12" data-id="element-53">Lo que dice la gente…</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-54">
            {[IMAGES.T1, IMAGES.T3, IMAGES.T4].map((img, i) => <div key={i} className="rounded-xl overflow-hidden shadow-lg" data-id="element-55">
                <img src={img} alt={`Testimonio ${i + 1}`} className="w-full h-auto object-contain" data-id="element-56" />
              </div>)}
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-[#F59E0B] font-bold hover:underline" data-id="element-57">
            Si también te gustó, mandanos un mensaje a nuestro Instagram!
          </a>
        </div>
      </section>

      {/* 7. OBJECTION HANDLING (Black) */}
      <section className="bg-black text-white py-16 px-4" data-id="element-58">
        <div className="max-w-4xl mx-auto" data-id="element-59">
          <div className="text-center mb-12" data-id="element-60">
            <h2 className="text-3xl font-bold mb-4" data-id="element-61">
              Las dudas normales antes de empezar
            </h2>
            <p className="text-gray-400" data-id="element-62">
              ( y por qué no te tienen que frenar )
            </p>
          </div>

          <div className="space-y-8" data-id="element-63">
            {[{
            q: '"Siento que no estoy listo todavía"',
            a: 'La mayoría empieza sin estar "listo". Este pack está pensado justamente para eso: para que no tengas que saber, ni pensar, ni improvisar. Arrancás con todo servido.'
          }, {
            q: '"No tengo tiempo para aprender algo nuevo"',
            a: 'No es un curso, no es teoría, no es estudio. Es elegir un diseño, cortarlo y vender. Mientras otros aprenden, vos avanzás.'
          }, {
            q: '"¿Y si no vendo?"',
            a: 'Podés usar los diseños para probar, mostrar, tomar pedidos y recién después producir. Primero validás. Después invertís.'
          }].map((item, idx) => <div key={idx} className="bg-gray-900 p-8 rounded-xl border-l-4 border-[#F59E0B]" data-id="element-64">
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-65">{item.q}</h3>
                <p className="text-gray-400" data-id="element-66">{item.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 9. WHAT'S INCLUDED (Black) */}
      <section className="bg-black text-white py-16 px-4" data-id="element-67">
        <div className="max-w-5xl mx-auto bg-gray-900 rounded-2xl p-8 md:p-12 border border-gray-800" data-id="element-68">
          <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-69">
            ¿Qué incluye Ultrapack Corte Láser?
          </h2>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-70">
            <div data-id="element-71">
              <div className="flex items-center gap-3 mb-4" data-id="element-72">
                <div className="text-[#F59E0B] w-8 h-8" data-id="element-73" />
                <h3 className="text-xl font-bold" data-id="element-74">
                  Más de 100.000 diseños vectoriales
                </h3>
              </div>
              <p className="text-gray-400 mb-6 pl-11" data-id="element-75">
                En formatos profesionales:
              </p>
              <div className="flex gap-4 pl-11" data-id="element-76">
                {['DXF', 'EPS', 'SVG'].map(fmt => <span key={fmt} className="bg-gray-800 px-4 py-2 rounded-lg font-mono font-bold border border-gray-700" data-id="element-77">
                    {fmt}
                  </span>)}
              </div>
            </div>

            <div className="space-y-4" data-id="element-78">
              <h3 className="text-xl font-bold mb-4 flex items-center gap-3" data-id="element-79">
                <CheckCircleIcon className="text-[#F59E0B] w-8 h-8" data-id="element-80" />
                Todos los archivos están:
              </h3>
              <ul className="space-y-3 pl-11" data-id="element-81">
                <li className="flex items-center gap-2 text-gray-300" data-id="element-82">
                  <Star className="w-4 h-4 text-[#F59E0B]" data-id="element-83" /> En alta calidad
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-84">
                  <ShieldCheck className="w-4 h-4 text-[#F59E0B]" data-id="element-85" /> Sin marcas
                  de agua
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-86">
                  <Scissors className="w-4 h-4 text-[#F59E0B]" data-id="element-87" /> Listos para
                  cortar
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 10. GUARANTEE (White) */}
      <section className="bg-white py-16 px-4" data-id="element-88">
        <div className="max-w-3xl mx-auto text-center" data-id="element-89">
          <div className="w-20 h-20 bg-[#F59E0B]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-90">
            <ShieldCheck className="w-10 h-10 text-[#F59E0B]" data-id="element-91" />
          </div>
          <h2 className="text-3xl font-bold mb-6" data-id="element-92">Probalo sin riesgo</h2>
          <p className="text-xl text-gray-600 mb-6" data-id="element-93">
            Queremos que te sientas tranquilo al comprar.
          </p>
          <p className="text-gray-600 leading-relaxed" data-id="element-94">
            Por eso tenés{' '}
            <span className="font-bold text-black" data-id="element-95">7 días de garantía</span>{' '}
            para probar el pack con calma. Si no es lo que esperabas, nos
            escribís y te devolvemos el 100% de tu dinero, sin preguntas ni
            vueltas.
          </p>
          <p className="mt-6 font-bold text-[#F59E0B]" data-id="element-96">
            Simple, justo y transparente.
          </p>
        </div>
      </section>

      {/* 11. PROMISE (Black) */}
      <section className="bg-black text-white py-16 px-4 text-center" data-id="element-97">
        <h2 className="text-3xl font-bold mb-8" data-id="element-98">La promesa es clara</h2>
        <div className="flex flex-col md:flex-row justify-center gap-8 text-xl" data-id="element-99">
          <p className="flex items-center justify-center gap-2" data-id="element-100">
            <span className="text-[#F59E0B]" data-id="element-101">👉</span> Nunca más quedarte sin
            qué vender.
          </p>
          <p className="flex items-center justify-center gap-2" data-id="element-102">
            <span className="text-[#F59E0B]" data-id="element-103">👉</span> Empezar a generar
            ingresos desde el primer día.
          </p>
        </div>
        <p className="mt-8 text-gray-400 max-w-2xl mx-auto" data-id="element-104">
          No importa si recién empezás o si ya trabajás con corte láser hace
          tiempo. Si tenés (o estás por tener) una máquina de corte láser, esto
          es para vos.
        </p>
      </section>

      {/* 12. PRICING SECTION (Black) */}
      <section id="pricing" className="bg-black py-20 px-4" data-id="element-105">
        <div className="max-w-7xl mx-auto" data-id="element-106">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-107">
            {/* PACK BASE - Fondo blanco */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-lg overflow-hidden flex flex-col h-full" data-id="element-108">
              <div className="p-6 bg-gray-50 border-b border-gray-200 text-center" data-id="element-109">
                <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-110">
                  🎯 PACK BASE
                </h3>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-111">
                  <span className="text-gray-400 line-through text-lg" data-id="element-112">
                    $50.000
                  </span>
                  <span className="text-[#F59E0B] font-bold text-3xl" data-id="element-113">
                    $19.990
                  </span>
                </div>
              </div>
              <div className="p-6 flex-1 bg-white" data-id="element-114">
                <img src={IMAGES.PACK1} alt="Pack Base" className="w-full h-48 object-contain mb-6" data-id="element-115" />
                <ul className="space-y-3 text-sm text-gray-700 mb-8" data-id="element-116">
                  <li className="flex gap-2" data-id="element-117">
                    <span data-id="element-118">🔧</span> +10.000 diseños listos
                  </li>
                  <li className="flex gap-2" data-id="element-119">
                    <span data-id="element-120">📂</span> Archivos vectoriales alta calidad
                  </li>
                  <li className="flex gap-2" data-id="element-121">
                    <span data-id="element-122">🧠</span> Diseños para vender todo el año
                  </li>
                  <li className="flex gap-2" data-id="element-123">
                    <span data-id="element-124">⏱️</span> Ahorrás horas de diseño
                  </li>
                  <li className="flex gap-2" data-id="element-125">
                    <span data-id="element-126">🚀</span> Acceso inmediato
                  </li>
                  <li className="flex gap-2 text-gray-400" data-id="element-127">
                    <span className="text-red-500" data-id="element-128">❌</span> No incluye sistema
                    venta sin stock
                  </li>
                  <li className="flex gap-2 text-gray-400" data-id="element-129">
                    <span className="text-red-500" data-id="element-130">❌</span> No incluye guía de
                    arranque
                  </li>
                  <li className="flex gap-2 text-gray-400" data-id="element-131">
                    <span className="text-red-500" data-id="element-132">❌</span> No incluye diseños
                    premium
                  </li>
                </ul>
                <Button fullWidth onClick={() => window.open('https://shop.ultrapack.digital/cart/46878219567253:1', '_blank')} data-id="element-133">
                  QUIERO EMPEZAR AHORA
                </Button>
              </div>
            </div>

            {/* ULTRAPACK DELUXE (Highlighted) */}
            <div className="bg-gray-900 rounded-2xl border-2 border-[#F59E0B] shadow-2xl shadow-[#F59E0B]/20 overflow-hidden transform lg:scale-105 relative z-10 flex flex-col h-full" data-id="element-134">
              <div className="bg-[#F59E0B] text-black text-center py-2 font-bold text-sm uppercase tracking-wider" data-id="element-135">
                Oferta por tiempo limitado
              </div>
              <div className="p-6 bg-gray-800 border-b border-gray-700 text-center" data-id="element-136">
                <h3 className="text-2xl font-bold mb-2 text-white" data-id="element-137">
                  💎 ULTRAPACK DELUXE
                </h3>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-138">
                  <span className="text-gray-500 line-through text-lg" data-id="element-139">
                    $60.000
                  </span>
                  <span className="text-[#F59E0B] font-bold text-4xl" data-id="element-140">
                    $26.990
                  </span>
                </div>
              </div>
              <div className="p-6 flex-1" data-id="element-141">
                <img src={IMAGES.PACK2} alt="Ultrapack Deluxe" className="w-full h-48 object-contain mb-6" data-id="element-142" />
                <ul className="space-y-3 text-sm text-gray-300 mb-6" data-id="element-143">
                  <li className="flex gap-2" data-id="element-144">
                    <span data-id="element-145">🔥</span> +100.000 diseños listos
                  </li>
                  <li className="flex gap-2" data-id="element-146">
                    <span data-id="element-147">🗂️</span> +450 carpetas organizadas
                  </li>
                  <li className="flex gap-2" data-id="element-148">
                    <span data-id="element-149">🪵</span> Diseños madera y MDF
                  </li>
                  <li className="flex gap-2" data-id="element-150">
                    <span data-id="element-151">🧩</span> Decorativos y funcionales
                  </li>
                  <li className="flex gap-2" data-id="element-152">
                    <span data-id="element-153">🛍️</span> Productos vendibles todo el año
                  </li>
                  <li className="flex gap-2" data-id="element-154">
                    <span data-id="element-155">🖼️</span> Recursos visuales HD
                  </li>
                  <li className="flex gap-2" data-id="element-156">
                    <span data-id="element-157">♻️</span> Acceso a futuras actualizaciones
                  </li>
                </ul>

                {/* Bonus Section */}
                <div className="pt-4 border-t border-gray-700 mt-4 space-y-4" data-id="element-158">
                  <p className="font-bold text-white text-center" data-id="element-159">
                    Y además...
                  </p>

                  <div className="bg-gray-800/50 rounded-lg p-4" data-id="element-160">
                    <p className="font-bold text-[#F59E0B] mb-2" data-id="element-161">
                      📄 Sistema simple "Vendé sin stock"
                    </p>
                    <ul className="text-sm text-gray-400 space-y-1 ml-4" data-id="element-162">
                      <li data-id="element-163">• Cómo tomar pedidos</li>
                      <li data-id="element-164">• Cómo cobrar antes</li>
                      <li data-id="element-165">• Cómo producir después</li>
                      <li data-id="element-166">• Método de bajo riesgo y mínima inversión</li>
                    </ul>
                  </div>

                  <div className="bg-gray-800/50 rounded-lg p-4" data-id="element-167">
                    <p className="font-bold text-green-500 mb-2" data-id="element-168">
                      ✅ Checklist "Primeras 48 horas"
                    </p>
                    <ul className="text-sm text-gray-400 space-y-1 ml-4" data-id="element-169">
                      <li data-id="element-170">• Qué hacer hoy</li>
                      <li data-id="element-171">• Qué publicar</li>
                      <li data-id="element-172">• Qué vender primero</li>
                      <li data-id="element-173">• Pasos claros para empezar sin trabarte</li>
                    </ul>
                  </div>
                </div>

                <div className="mt-6" data-id="element-174">
                  <Button fullWidth size="lg" onClick={() => window.open('https://shop.ultrapack.digital/cart/46921507438741:1', '_blank')} className="animate-pulse" data-id="element-175">
                    QUIERO EMPEZAR AHORA
                  </Button>
                </div>
              </div>
            </div>

            {/* ULTRAPACK VIP - Violeta oscuro */}
            <div className="bg-[#2D1B4E] rounded-2xl border-2 border-[#7C3AED] shadow-xl shadow-[#7C3AED]/20 overflow-hidden flex flex-col h-full mt-4 lg:mt-0" data-id="element-176">
              <div className="p-6 bg-[#3D2463] border-b border-[#7C3AED] text-center" data-id="element-177">
                <h3 className="text-2xl font-bold mb-2 text-[#A78BFA]" data-id="element-178">
                  ⚡️ ULTRAPACK VIP
                </h3>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-179">
                  <span className="text-gray-400 line-through text-lg" data-id="element-180">
                    $80.000
                  </span>
                  <span className="text-[#F59E0B] font-bold text-3xl" data-id="element-181">
                    $39.990
                  </span>
                </div>
              </div>
              <div className="p-6 flex-1" data-id="element-182">
                <img src={IMAGES.PACK3} alt="Ultrapack VIP" className="w-full h-48 object-contain mb-6" data-id="element-183" />
                <p className="text-center text-[#A78BFA] font-bold mb-4" data-id="element-184">
                  Todo lo del ultrapack deluxe y además...
                </p>
                <ul className="space-y-4 text-sm text-gray-300 mb-8" data-id="element-185">
                  <li data-id="element-186">
                    <strong className="text-white block mb-1" data-id="element-187">
                      ✉️ Tarjetas de negocio editables
                    </strong>
                    Plantillas listas para presentarte de forma profesional.
                  </li>
                  <li data-id="element-188">
                    <strong className="text-white block mb-1" data-id="element-189">
                      🔤 Pack con +120.000 fuentes
                    </strong>
                    Biblioteca enorme de tipografías.
                  </li>
                  <li data-id="element-190">
                    <strong className="text-white block mb-1" data-id="element-191">
                      🎨 Pack con +1.000 texturas
                    </strong>
                    Texturas editables para terminación premium.
                  </li>
                </ul>
                <Button fullWidth onClick={() => window.open('https://shop.ultrapack.digital/cart/46921509994645:1', '_blank')} className="bg-[#7C3AED] hover:bg-[#6D28D9] text-white border-0" data-id="element-192">
                  QUIERO EMPEZAR AHORA
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* URGENCY SECTION - Nueva sección de escasez */}
      <section className="bg-gradient-to-b from-gray-900 to-black py-16 px-4" data-id="element-193">
        <div className="max-w-3xl mx-auto text-center" data-id="element-194">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#F59E0B]/10 border border-[#F59E0B]/30 rounded-full px-4 py-2 mb-8" data-id="element-195">
            <span className="w-2 h-2 bg-[#F59E0B] rounded-full animate-pulse" data-id="element-196"></span>
            <span className="text-[#F59E0B] text-sm font-medium uppercase tracking-wider" data-id="element-197">
              Acceso limitado · Disponible hoy
            </span>
          </div>

          {/* Título */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-198">
            Este precio especial no va a estar disponible por mucho tiempo
          </h2>

          {/* Subtítulo */}
          <p className="text-xl text-gray-400 mb-10" data-id="element-199">
            Última oportunidad para acceder a esta oferta
          </p>

          {/* Countdown */}
          <div className="mb-10" data-id="element-200">
            <CountdownTimer data-id="element-201" />
          </div>

          {/* Trust indicators */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-10 text-sm text-gray-400" data-id="element-202">
            <div className="flex items-center gap-2" data-id="element-203">
              <Zap className="w-5 h-5 text-[#F59E0B]" data-id="element-204" />
              <span data-id="element-205">Acceso inmediato al contenido</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-206">
              <CreditCard className="w-5 h-5 text-[#F59E0B]" data-id="element-207" />
              <span data-id="element-208">Compra protegida con Mercado Pago</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-209">
              <Shield className="w-5 h-5 text-[#F59E0B]" data-id="element-210" />
              <span data-id="element-211">7 días de garantía de devolución</span>
            </div>
          </div>

          {/* CTA */}
          <Button size="lg" onClick={scrollToPricing} className="text-lg px-12 py-6 h-auto" data-id="element-212">
            Quiero asegurar mi acceso ahora
          </Button>
        </div>
      </section>

      {/* 13. FINAL CTA (Black) */}
      <section className="bg-black text-white py-20 px-4 text-center border-t border-gray-800" data-id="element-213">
        <div className="max-w-3xl mx-auto" data-id="element-214">
          <h2 className="text-4xl font-bold mb-6" data-id="element-215">Estás a un paso</h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-216">
            De dejar de improvisar. De dejar de perder tiempo. De empezar a
            vender con confianza.
          </p>
          <Button size="lg" onClick={scrollToPricing} className="text-lg px-12" data-id="element-217">
            👉 Descargá el Ultrapack ahora
          </Button>
        </div>
      </section>

      {/* 14. FAQ (White) */}
      <section className="bg-white py-20 px-4" data-id="element-218">
        <div className="max-w-3xl mx-auto" data-id="element-219">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-220">
            Preguntas Frecuentes
          </h2>
          <FAQ data-id="element-221" />
        </div>
      </section>

      {/* 15. CLOSING (Black) */}
      <section className="bg-black text-white py-24 px-4 text-center border-t border-gray-900" data-id="element-222">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight" data-id="element-224">
            Esto no se piensa tanto.{' '}
            <span className="text-[#F59E0B]" data-id="element-225">Se hace.</span>
          </h2>
          <p className="text-2xl text-gray-300" data-id="element-226">
            El que arranca primero es el que vende primero.
          </p>
          <p className="text-xl text-gray-400" data-id="element-227">Vos decidís cuándo empezar.</p>
          <div className="pt-8" data-id="element-228">
            <Button size="lg" onClick={scrollToPricing} className="text-xl px-16 py-6 h-auto" data-id="element-229">
              Empezar Ahora
            </Button>
          </div>
        </div>
      </section>
    </div>;
}
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-230">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-231" />
      <polyline points="22 4 12 14.01 9 11.01" data-id="element-232" />
    </svg>;
}